<div class="utilizadores_page">
  <!-- ── HEADER ───────────────────────────────────────── -->
  <div class="page-header">
    <div>
      <h1>Gestão de Utilizadores</h1>
      <p>{{ totalCount }} contas registadas</p>
    </div>
    <div class="page-actions">
      <button
        class="btn-web-secondary btn-filtros"
        (click)="filtrosPainelAberto = true"
      >
        <i class="pi pi-filter"></i> Filtros
        <span class="filtros-badge" *ngIf="activeFilterCount > 0">{{
          activeFilterCount
        }}</span>
      </button>
      <button class="btn-web-primary" (click)="criarUtilizador()">
        <i class="pi pi-plus"></i> Novo Utilizador
      </button>
    </div>
  </div>

  <!-- ── FILTER TABS ──────────────────────────────────── -->
  <div class="filters-row">
    <button
      class="filter-chip"
      [class.active]="activeTab === 'todos'"
      (click)="setActiveTab('todos')"
    >
      Todos ({{ totalCount }})
    </button>
    <button
      class="filter-chip"
      [class.active]="activeTab === 'ADMIN'"
      (click)="setActiveTab('ADMIN')"
    >
      Administradores ({{ totalCountAdmin }})
    </button>
    <button
      class="filter-chip"
      [class.active]="activeTab === 'CLIENTE'"
      (click)="setActiveTab('CLIENTE')"
    >
      Clientes ({{ totalCountCliente }})
    </button>
    <button
      class="filter-chip"
      [class.active]="activeTab === 'EFETIVO'"
      (click)="setActiveTab('EFETIVO')"
    >
      Efetivos ({{ totalCountEfetivo }})
    </button>
  </div>

  <!-- ── CHIPS DE FILTROS APLICADOS ───────────────────── -->
  <div class="filtros-chips-row" *ngIf="filtroChips.length > 0">
    <span class="filtro-chip" *ngFor="let chip of filtroChips">
      {{ chip.label }}
      <button
        type="button"
        (click)="removerFiltro(chip.key)"
        aria-label="Remover filtro"
      >
        <i class="pi pi-times"></i>
      </button>
    </span>
  </div>

  <!-- ── LIST ─────────────────────────────────────────── -->
  <div class="listar-utilizadores-content">
    <app-lista-utilizadores
      [pagination]="pagination"
      [skeletonLoading]="skeletonLoading"
      (pageChange)="onPageChange($event)"
      (editar)="onEditar($event)"
      (resetarSenha)="onResetarSenha($event)"
      (gerirGrupos)="onGerirGrupos($event)"
    >
    </app-lista-utilizadores>
  </div>
</div>

<app-gerir-grupos-utilizador
  [(visible)]="mostrarDialogGrupos"
  [utilizador]="utilizadorSelecionado"
></app-gerir-grupos-utilizador>

<!-- ── FILTROS OVERLAY ──────────────────────────────────── -->
<div
  class="filtros-overlay"
  [class.open]="filtrosPainelAberto"
  (click)="filtrosPainelAberto = false"
></div>

<!-- ── FILTROS DRAWER ──────────────────────────────────── -->
<div class="filtros-drawer" [class.open]="filtrosPainelAberto">
  <div class="filtros-header">
    <h3 class="fd-title">
      <i class="ri-equalizer-3-line"></i>
      Filtros de Utilizadores
    </h3>
    <button type="button" class="filtros-close-btn" (click)="filtrosPainelAberto = false">
      <i class="fas fa-times"></i>
    </button>
  </div>

  <div class="filtros-body" [formGroup]="filtrosForm">
    <div class="filtro-grupo">
      <label>Nome</label>
      <input
        class="form-input"
        formControlName="Nome"
        placeholder="Pesquisar por nome..."
        (keydown.enter)="$event.preventDefault(); aplicarFiltrosDrawer()"
      />
    </div>
    <div class="filtro-grupo">
      <label>User ID</label>
      <input
        class="form-input"
        formControlName="UserId"
        placeholder="8fd0fe6e..."
      />
    </div>
    <div class="filtro-grupo">
      <label>E-mail</label>
      <input
        class="form-input"
        formControlName="Email"
        placeholder="Pesquisar por e-mail..."
      />
    </div>
    <div class="filtro-grupo">
      <label>NIF</label>
      <input
        class="form-input"
        formControlName="UserName"
        placeholder="NIF de utilizador..."
      />
    </div>
    <div class="filtro-grupo">
      <label>Perfil</label>
      <p-select
        formControlName="TipoPerfilEnum"
        [options]="perfilOptions"
        optionLabel="label"
        optionValue="value"
        placeholder="Todos"
        styleClass="w-full"
        appendTo="body"
        [showClear]="true"
      >
      </p-select>
    </div>
    <div class="filtro-grupo">
      <label>Estado</label>
      <p-select
        formControlName="IsActive"
        [options]="estadoOptions"
        optionLabel="label"
        optionValue="value"
        placeholder="Todos"
        styleClass="w-full"
        appendTo="body"
        [showClear]="true"
      >
      </p-select>
    </div>
  </div>

  <div class="filtros-footer">
    <button type="button" class="btn-web-secondary" style="flex:  1" (click)="$event.preventDefault(); $event.stopPropagation(); limparFiltros()">
      <i class="fas fa-undo"></i> Limpar
    </button>
    <button type="button" class="btn-web-primary" style="flex: 2" (click)="aplicarFiltrosDrawer()">
      <i class="fas fa-check"></i> Aplicar
    </button>
  </div>
</div>

<!-- ── DRAWER CRIAR UTILIZADOR ── -->
<app-criar-utilizador
  [(visible)]="mostrarDrawerCriar"
  [defaultPerfil]="activeTab !== 'todos' ? activeTab : 'EFETIVO'"
  (saved)="loadUtilizadores()"
></app-criar-utilizador>

<!-- ── DRAWER EDITAR UTILIZADOR ── -->
<app-editar-utilizador
  [(visible)]="mostrarDrawerEditar"
  [utilizador]="utilizadorSelecionado"
  (saved)="reloadCurrentPage()"
></app-editar-utilizador>

<!-- ── DIALOG RESETAR SENHA ── -->
<app-resetar-senha-dialog
  [(visible)]="mostrarDialogReset"
  [utilizador]="utilizadorSelecionado"
  (saved)="reloadCurrentPage()"
></app-resetar-senha-dialog>
